module.exports = __webpack_public_path__ + "static/img/040 1.d47dd814.jpg";